import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, List, ListItem, ListItemText, Chip, Stack } from '@mui/material';
import type { AppVersionInfo, ChangelogResponse, ChangelogItem } from '../../services/versionService';

interface UpdateNotesDialogProps {
  open: boolean;
  onClose: () => void;
  versionInfo: AppVersionInfo | null;
  changelog: ChangelogResponse | null;
}

const typeToColor: Record<string, 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info' | undefined> = {
  feature: 'success',
  improvement: 'primary',
  fix: 'warning',
  bugfix: 'warning',
  breaking: 'error',
  docs: 'default'
};

export default function UpdateNotesDialog({ open, onClose, versionInfo, changelog }: UpdateNotesDialogProps) {
  const items: ChangelogItem[] = Array.isArray(changelog?.items) ? changelog!.items! : [];
  const versionLabel = versionInfo?.version || changelog?.version;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {versionLabel ? `Co nowego w wersji ${versionLabel}?` : 'Co nowego w aplikacji?'}
      </DialogTitle>
      <DialogContent dividers>
        {items.length > 0 ? (
          <List>
            {items.map((it, idx) => (
              <ListItem key={idx} alignItems="flex-start" sx={{ px: 0 }}>
                <ListItemText
                  primary={
                    <Stack direction="row" spacing={1} alignItems="center">
                      {it.type ? <Chip size="small" label={it.type} color={typeToColor[it.type] || 'default'} /> : null}
                      <Typography variant="subtitle1" fontWeight={600}>{it.title}</Typography>
                    </Stack>
                  }
                  secondary={it.body ? <Typography variant="body2" color="text.secondary">{it.body}</Typography> : null}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box>
            <Typography variant="body1" gutterBottom>
              Aplikacja została zaktualizowana{versionLabel ? ` do wersji ${versionLabel}` : ''}.
            </Typography>
            {versionInfo?.buildAt ? (
              <Typography variant="body2" color="text.secondary">
                Data kompilacji: {new Date(versionInfo.buildAt).toLocaleString()}
              </Typography>
            ) : null}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">OK</Button>
      </DialogActions>
    </Dialog>
  );
}


